import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import OfferingBgImage from "public/openStack/background.png";
import { IMPLEMENTATION_CONSTANTS } from "./constants";
import PlainTextFrame from "@/components/plainText";

const Implementation = () => {
  return (
    <Box backgroundImage={OfferingBgImage.src} backgroundSize="cover" pb={14}>
      <PageLayout>
        <PlainTextFrame {...IMPLEMENTATION_CONSTANTS} />
      </PageLayout>
    </Box>
  );
};

export default Implementation;
